import { NetworkConstants } from '../network-constants';
import { getEntityStateRenderer } from '../../common/common-renderers';
export function getNetworkListingDatatableConfig() {
    return {
        dom: 'Bfrtip',
        columns: [
            { 'data': 'name', 'title': 'Name' },
            { 'data': 'description', 'title': 'Description' },
            { 'data': 'ipScopes', 'title': 'Gateway IPs' },
            { 'data': 'ipScopes', 'title': 'Prefix Length' },
            { 'data': 'scope', 'title': 'Scope' },
            { 'data': 'state', 'title': 'Status' }
        ],
        columnDefs: [
            {
                'targets': [0],
                'type': 'alt-string',
                 'mRender': function (data, type, row) {
                    if (data && row) {
                          let icon = getClrIcon(row);
                          return icon + '<span class="icon-text">'+ data + '</span>';
                    }
                    return '';
                }
            },
            {
                'targets': [1] ,
                'mRender': function (data, type, row) {
                    if (data) {
                         return data;
                    }
                    return '';
                }
            },
            {
                'targets': [2] ,
                'mRender': function (data, type, row) {
                    let formattedValue = '';
                    if(row.hasOwnProperty('ipScopes')){
                        row.ipScopes.map(function(item, index) {
                            formattedValue += item.gateway ? item.gateway : '';
                            formattedValue += '<br>';
                        })
                    }
                    return formattedValue;
                }
            },
            {
                'targets': [3] ,
                'mRender': function (data, type, row) {
                    let formattedValue = '';
                    if(row.hasOwnProperty('ipScopes')){
                        row.ipScopes.map(function(item, index) {
                            formattedValue += item.prefixLength;
                            formattedValue += '<br>';
                        })
                    }
                    return formattedValue;
                }
            },
            { 
                'targets': [4] ,
                'mRender': function (data, type, row) {
                    if (data) {
                        return getNetworkValue(data,row);
                    }
                    return '';
                }
            },
            { 
                'targets': [5] ,
                'mRender': function (data, type, row) {
                    if (data) {
                        return getEntityStateRenderer(data);
                    }
                    return '';
                }
            }
        ],
        'autoWidth': false,
        'oLanguage': {
            'sSearch': '',
            'sEmptyTable': '',
            'sInfoEmpty': ''
        },
        'scrollY': '100vh',
        'scrollCollapse': true,
        'paging': false,
        'bFilter': true,
        'bDestroy': true,
        'bUseRendered': false,
        'order': [[0, 'desc']],
        'rowCallback': function (row, data) {
        }
    };
}
function getRangeValues(ipRanges) {
    let range = '';
    ipRanges.map(function(item, index) {
        if (index !== 0) {
            range += '<br>';
        }
        range += item.startAddress + ' - ' + item.endAddress;
    });
    return range;
}
function getNetworkValue(scopes: Array<String>, network){
    let value: string = '';
    let icon: string = "";
    let displayRenderer: string;
    if ( scopes.length > 0) {
        icon = '<clr-icon shape="vc" class="is-highlight" size="16"></clr-icon>';
        value = (network && network.scopeNames && network.scopeNames[0]) ? network.scopeNames[0] : '';
    } else {
        icon = '<clr-icon shape="world" class="is-highlight" size="16"></clr-icon>';
        value = 'Global';
    }

    return  icon + '<span style="margin-left:5px">' + value + '</span>';
}

function getClrIcon(network) {
    /*
    Internet l3TenantManaged:false, ownedBySystem:true
    DirectConnect l3TenantManaged:true, ownedBySystem:true
    Trunk allowTrunkInterfaces: true,
    */

    // Trunk Interface
    if (typeof network.allowTrunkInterfaces !== "undefined" && network.allowTrunkInterfaces) {
        return '<clr-icon shape="trunk-network" class="is-highlight" size="16"></clr-icon>';
    }

    if (network.ownedBySystem) {
        if (network.l3TenantManaged) {
            // Direct Connect
            return '<clr-icon shape="direct-connect" class="is-highlight" size="16"></clr-icon>';
        } else {
            // Internet
            return '<clr-icon shape="network-globe" class="is-highlight" size="16"></clr-icon>';
        }
    } else {
        // ownedBySystem: false, l3TenantManaged: true, !scopeNames
        if (network.l3TenantManaged && typeof network.scopeNames === "undefined") {
            // Transit
            return '<clr-icon shape="cloud-network" class="is-highlight"></clr-icon>';
        }
    }
    //Local NW l3lManaged = true, ownedBySystem = false & scopeNames 

    // Default Icon
    return '<clr-icon shape="network-default" class="is-highlight" size="16"></clr-icon>';
}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/networks/listing/network-listing.dt.config.ts